const snowFragmentShader = /* glsl */ `
precision highp float;

uniform sampler2D uHeightMap;
uniform float uDepth;
uniform vec3 uSnowColor;
uniform vec3 uLightDirection;

varying vec2 vUv;

const float TEXEL_SIZE = 1.0 / 512.0;
const float SNOW_SIZE = 10.0;

void main() {
  float hL =
    texture2D(uHeightMap, vUv + vec2(-TEXEL_SIZE, 0.0)).r * uDepth;

  float hR =
    texture2D(uHeightMap, vUv + vec2(TEXEL_SIZE, 0.0)).r * uDepth;

  float hD =
    texture2D(uHeightMap, vUv + vec2(0.0, -TEXEL_SIZE)).r * uDepth;

  float hU =
    texture2D(uHeightMap, vUv + vec2(0.0, TEXEL_SIZE)).r * uDepth;

  float worldTexel = SNOW_SIZE / 512.0;

  float slopeX = (hR - hL) / (2.0 * worldTexel);
  float slopeZ = (hU - hD) / (2.0 * worldTexel);

  vec3 normal = normalize(vec3(slopeX, 1.0, slopeZ));
  vec3 lightDirection = normalize(uLightDirection);

  float NdotL = max(dot(normal, lightDirection), 0.0);
  float lighting = 0.28 + NdotL * 0.72;

  vec3 shadowTint = vec3(0.82, 0.89, 0.96);
  vec3 litColor = uSnowColor * lighting;
  vec3 color = mix(litColor * shadowTint, litColor, NdotL);

  gl_FragColor = vec4(color, 1.0);
}
`;

export default snowFragmentShader;
